module.exports = __webpack_public_path__ + "static/media/product.104888a2.svg";